import { userVar } from "lib/user";
import { calculateAge, checkOptInTracking } from "tracking/utils/users";
import { useEffect } from "react";
import { useSegment } from "./useSegment";

export const setSessionStart = (): boolean => {
  if (typeof window === "undefined") return false;
  const storage = window.sessionStorage;
  if (!storage) return false;
  if (!storage.getItem("sessionStart")) {
    storage.setItem("sessionStart", "true");
    return true;
  }
  return false;
};

export const useSegmentIdentify = () => {
  const { identify } = useSegment();

  const user = userVar();

  useEffect(() => {
    if (user.isLoggedIn === false) return;

    if (setSessionStart()) {
      identify({
        traits: {
          triggeredBy: "PAGE_LOAD",
          membershipStatus: user.isMember ? "MEMBER" : "NON_MEMBER",
          optInTracking: checkOptInTracking(),
          activeMembershipSku: user.membership?.value,
          activeMembershipSkuTerm: user.membership?.duration,
          age: calculateAge(user.dateOfBirth),
          birthday: user.dateOfBirth ?? undefined,
          createdAt: user.registrationDateTime ?? undefined,
          email: user.email,
          firstName: user.firstName ?? "",
          lastName: user.lastName ?? "",
          name: user.fullName
        }
      });
    }
  }, [user, identify]);
};
